import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FaPhone, FaLock } from "react-icons/fa";
import {
  json,
  redirect,
  Form,
  useNavigation,
  useActionData,
  Link,
} from "react-router-dom";
import { PulseLoader } from "react-spinners";

import { trackViewContent } from "../Pixel/metaPixelEvents";

const LoginWithOtp = () => {
  const [step, setStep] = useState(1);
  const [phoneNumber, setPhoneNumber] = useState("");

  const navigation = useNavigation();

  const [loading, setLoading] = useState(false);
  const isSubmitting = navigation.state === "submitting";
  const data = useActionData();

  useEffect(() => {
    trackViewContent();
  }, []);

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData(e.target);
    const userData = Object.fromEntries(formData.entries());

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/otp/sendotp`,
        {
          method: "POST",
          body: JSON.stringify(userData),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const resData = await res.json();

      console.log(resData);

      if (!res.ok) {
        throw new Error(resData.message || "Failed to send OTP.");
      }
      setStep(2);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      throw json(
        { message: "Failed to send OTP. Please try again later." },
        { status: 500 }
      );
    }
  };

  function handleGoLoginPage() {
    setStep(1);
  }

  // const inputClasses =
  //   "w-full px-4 py-2 text-gray-700 bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:bg-white transition-all duration-300";
  // const labelClasses = "block mb-2 text-sm font-medium text-gray-600";
  // const buttonClasses =
  //   "w-full px-4 py-2 text-white bg-yellow-500 rounded-md hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50 transition-all duration-300";

  const inputClasses =
    "w-full px-4 py-3 text-gray-800 placeholder-gray-400 bg-gray-50/50 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-200 transition-all duration-300";

  const labelClasses = "block text-sm font-medium text-gray-700 mb-2";

  const buttonClasses =
    "w-full flex justify-center items-center py-3 px-4 bg-black text-white rounded-lg font-medium hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-all duration-300";

  return (
    // <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-yellow-100 to-yellow-300 p-4">
    //   <motion.div
    //     initial={{ opacity: 0, y: -50 }}
    //     animate={{ opacity: 1, y: 0 }}
    //     transition={{ duration: 0.5 }}
    //     className="w-full max-w-md bg-white rounded-xl shadow-2xl overflow-hidden"
    //   >
    //     <div className="p-8">
    //       <h2 className="text-3xl font-extrabold text-center mb-6 text-gray-800">
    //         Login with OTP
    //       </h2>
    //       {step === 1 ? (
    //         <form onSubmit={handleSendOtp} className="space-y-6">
    //           <div>
    //             <label htmlFor="phoneNumber" className={labelClasses}>
    //               <FaPhone className="inline mr-2" />
    //               Enter Mobile Number
    //             </label>
    //             <div className="flex items-center border border-gray-300 rounded-lg focus-within:ring-2 focus-within:ring-yellow-400 transition-all duration-300">
    //               <span className="text-gray-600 font-semibold pl-4 mr-2">
    //                 +91
    //               </span>
    //               <motion.input
    //                 whileFocus={{ scale: 1.02 }}
    //                 id="phoneNumber"
    //                 type="tel"
    //                 name="phoneNumber"
    //                 value={phoneNumber}
    //                 onChange={(e) => setPhoneNumber(e.target.value)}
    //                 className={`${inputClasses} border-0`}
    //                 placeholder="Enter your phone number"
    //                 required
    //               />
    //             </div>
    //           </div>

    //           <motion.button
    //             whileHover={{ scale: 1.05 }}
    //             whileTap={{ scale: 0.95 }}
    //             disabled={loading}
    //             className={buttonClasses}
    //           >
    //             {loading ? (
    //               <PulseLoader color="#ffffff" size={10} />
    //             ) : (
    //               "Send OTP"
    //             )}
    //           </motion.button>

    //           <div className="text-center text-sm text-gray-600">
    //             Not registered yet?{" "}
    //             <Link
    //               to="/signup"
    //               className="text-yellow-600 hover:text-yellow-700 font-medium transition-all"
    //             >
    //               Register here
    //             </Link>
    //           </div>
    //         </form>
    //       ) : (
    //         <Form method="post" action="/login" className="space-y-6">
    //           {data && data.message && (
    //             <motion.div
    //               initial={{ opacity: 0, y: -10 }}
    //               animate={{ opacity: 1, y: 0 }}
    //               className="p-3 bg-red-100 border border-red-400 text-red-700 text-sm rounded-md"
    //             >
    //               {data.message}
    //             </motion.div>
    //           )}

    //           <input type="hidden" name="phoneNumber" value={phoneNumber} />

    //           <div>
    //             <label htmlFor="otp" className={labelClasses}>
    //               <FaLock className="inline mr-2" />
    //               Enter OTP
    //             </label>
    //             <motion.input
    //               whileFocus={{ scale: 1.02 }}
    //               id="otp"
    //               type="number"
    //               name="otp"
    //               className={inputClasses}
    //               placeholder="Enter your OTP"
    //               required
    //               minLength={4}
    //             />
    //           </div>

    //           <motion.button
    //             whileHover={{ scale: 1.05 }}
    //             whileTap={{ scale: 0.95 }}
    //             disabled={isSubmitting}
    //             className={buttonClasses}
    //           >
    //             {isSubmitting ? (
    //               <PulseLoader color="#ffffff" size={10} />
    //             ) : (
    //               "Verify OTP"
    //             )}
    //           </motion.button>

    //           <div className="text-center text-sm text-gray-600">
    //             Not registered yet?{" "}
    //             <Link
    //               to="/signup"
    //               className="text-yellow-600 hover:text-yellow-700 font-medium transition-all"
    //             >
    //               Register here
    //             </Link>
    //           </div>

    //           <motion.button
    //             onClick={handleGoLoginPage}
    //             whileHover={{ scale: 1.05 }}
    //             whileTap={{ scale: 0.95 }}
    //             className="w-full py-2 px-4 border border-yellow-600 rounded-md shadow-sm text-sm font-medium text-yellow-600 bg-white hover:bg-yellow-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 transition-all"
    //           >
    //             Go to Login Page
    //           </motion.button>
    //         </Form>
    //       )}
    //     </div>
    //   </motion.div>
    // </div>

    <div className="min-h-screen flex items-center justify-center bg-white p-4">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.23, 1, 0.32, 1] }}
        className="w-full max-w-md"
      >
        <div className="mx-auto mb-8 text-center">
          <h1 className="text-4xl font-semibold text-gray-900 mb-2">Welcome</h1>
          <p className="text-gray-500">Sign in with your phone number</p>
        </div>

        <motion.div
          className="bg-white rounded-2xl p-8 shadow-lg"
          style={{
            boxShadow: "0 4px 24px -8px rgba(0, 0, 0, 0.1)",
          }}
        >
          {step === 1 ? (
            <form onSubmit={handleSendOtp} className="space-y-6">
              <div className="space-y-4">
                <label htmlFor="phoneNumber" className={labelClasses}>
                  Phone Number
                </label>
                <div className="flex items-center bg-gray-50/50 rounded-lg focus-within:ring-2 focus-within:ring-gray-200 transition-all duration-300">
                  <span className="text-gray-600 pl-4 pr-2 border-r border-gray-200">
                    +91
                  </span>
                  <motion.input
                    whileFocus={{ scale: 1.01 }}
                    id="phoneNumber"
                    type="tel"
                    name="phoneNumber"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    className="flex-1 px-4 py-3 bg-transparent border-none focus:outline-none text-gray-800"
                    placeholder="Enter your phone number"
                    required
                  />
                </div>
              </div>

              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                disabled={loading}
                className={buttonClasses}
              >
                {loading ? (
                  <PulseLoader color="#ffffff" size={8} />
                ) : (
                  "Continue"
                )}
              </motion.button>
            </form>
          ) : (
            <Form method="post" action="/login" className="space-y-6">
              {data?.message && (
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="p-4 bg-red-50 border border-red-100 text-red-600 text-sm rounded-lg"
                >
                  {data.message}
                </motion.div>
              )}

              <input type="hidden" name="phoneNumber" value={phoneNumber} />

              <div className="space-y-4">
                <label htmlFor="otp" className={labelClasses}>
                  Verification Code
                </label>
                <motion.input
                  whileFocus={{ scale: 1.01 }}
                  id="otp"
                  type="number"
                  name="otp"
                  className={inputClasses}
                  placeholder="Enter verification code"
                  required
                  minLength={4}
                />
              </div>

              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                disabled={isSubmitting}
                className={buttonClasses}
              >
                {isSubmitting ? (
                  <PulseLoader color="#ffffff" size={8} />
                ) : (
                  "Verify"
                )}
              </motion.button>

              <motion.button
                onClick={handleGoLoginPage}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="w-full py-3 px-4 border border-gray-200 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200 transition-all duration-300 mt-4"
              >
                Back to Login
              </motion.button>
            </Form>
          )}

          <div className="mt-6 text-center text-sm text-gray-500">
            Don't have an account?{" "}
            <Link
              to="/signup"
              className="text-black font-medium hover:underline transition-all"
            >
              Sign up
            </Link>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default LoginWithOtp;

export async function loginAction({ request, params }) {
  const formData = await request.formData();
  const userData = {
    otp: formData.get("otp"),
    phoneNumber: formData.get("phoneNumber"),
  };

  // Uncomment this section when ready to implement OTP verification

  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/otp/verify`,
      {
        method: "POST",
        body: JSON.stringify(userData),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 404 || response.status === 401) {
      return response;
    }

    const resData = await response.json();

    console.log(resData);

    const token = resData.token;

    localStorage.setItem("token", token);
    localStorage.setItem("userid", resData.userId);
    localStorage.setItem("phoneNumber", resData.phoneNumber);

    if (!response.ok) {
      throw new Error(resData.message || "Failed to login user.");
    }
  } catch (err) {
    throw json(
      { message: "Failed to login. Please try again later." },
      { status: 500 }
    );
  }

  return redirect("/");
}
